import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1781c5a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-md-12 result-pane",
  ref: "resultpane"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "col-md-12 pt-2 pb-2",
  style: {"color":"red"}
}, "Todays Jobs", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "col-md-12 pt-2 pb-2" }, "Date Range", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "col-md-12 pt-2 pb-2" }, "Future", -1))
const _hoisted_9 = {
  key: 1,
  class: "col-md-12 result-pane"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead text-center align-middle" }, "No Sms/Email logs found", -1))
const _hoisted_11 = [
  _hoisted_10
]

import { ref, inject, onMounted, onBeforeUnmount, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useEvent } from "@/eventBus";
import { Booking } from "@/models";
import UnreadSmsEmailLogstResultTemplate from "./UnreadSmsEmailLogstResultTemplate.vue";
import Ably from "ably";

export default /*#__PURE__*/_defineComponent({
  __name: 'UnreadSmsEmailLogs',
  props: {
    results: {},
    todaysunreadsmslogsresults: {},
    daterangeunreadsmslogsresults: {},
    futureunreadsmslogsresults: {}
  },
  emits: ["smslogsselected", "removesmsbookingfromlocal"],
  setup(__props: any, { emit: __emit }) {

const realtime: Ably.Realtime = inject("realtime");
const actProperty: any = inject("actProperty");
const channel = realtime.channels.get("diary");
const deviceid = actProperty.getDeviceId();
const emit = __emit;

// Props
const props = __props;
// Store access
const store = useStore();
const router = useRouter();
const route = useRoute();

// Data
const smsemailselectedbookingid = ref("");
const unsavedchangesonform = ref(false);
// Computed properties and getters
const smsemailselectedbooking = ref(new Booking());

// Methods
const getBooking = (id: string): Promise<Booking> => {
  return store.dispatch("diary/getBooking", id);
};

const isfocused = (b: Booking) => {
  if (b?.id) {
    if (smsemailselectedbookingid.value) {
      return b.id === smsemailselectedbookingid.value;
    }
    // else if (props.futurebookingid) {
    //   return b.id === props.futurebookingid;
    // }
  }
  return false;
};

// Events handling
onMounted(() => {
  useEvent("appointmentRestoredInBookingTemplate", (booking: any) => {
    let todayindex = props.todaysunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (todayindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.todaysunreadsmslogsresults.splice(todayindex, 1);
    }
    let daterangeindex = props.daterangeunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (daterangeindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.daterangeunreadsmslogsresults.splice(daterangeindex, 1);
    }
    let futureindex = props.futureunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (futureindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.futureunreadsmslogsresults.splice(daterangeindex, 1);
    }
  });
  useEvent("appointmentChangedInBookingTemplate", (booking: any) => {
    let todayindex = props.todaysunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (todayindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.todaysunreadsmslogsresults.splice(todayindex, 1);
      // eslint-disable-next-line vue/no-mutating-props
      props.todaysunreadsmslogsresults.push(booking);
    }
    let daterangeindex = props.daterangeunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (daterangeindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.daterangeunreadsmslogsresults.splice(daterangeindex, 1);
      // eslint-disable-next-line vue/no-mutating-props
      props.daterangeunreadsmslogsresults.push(booking);
    }
    let futureindex = props.futureunreadsmslogsresults.findIndex(
      (b: Booking) => b.id === booking.id
    );
    if (futureindex >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.futureunreadsmslogsresults.splice(futureindex, 1);
      // eslint-disable-next-line vue/no-mutating-props
      props.futureunreadsmslogsresults.push(booking);
    }
  });

  channel.subscribe("appointmentLoading", (message: any) => {
    if (message?.data) {
      if (message.data.deviceid != deviceid) return;
      if (!message.data.cancelled) {
        // If it is not a cancelled booking, highlight
        smsemailselectedbookingid.value = message.data.bookingid;
      } else {
        // If it is a cancelled booking, don't highlight, just set the smsemailselectedbookingid
        // so that the 2 second timeout does not open another tab
        smsemailselectedbookingid.value = message.data.bookingid;
      }
    }
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe('appointmentLoading');
});


const selectbooking = async (booking: Booking) => {
  if (booking.id) {
    channel.publish("appointmentSelected", {
      deviceid: deviceid,
      bookingid: booking.id,
      inspectorid: booking.inspector?.id,
      googleid: booking.googleid,
      subtype: booking.subtype,
      jobtype: booking.jobtype,
      bookingdate: booking.bookingdate,
    });
    channel.publish("appointmentSelectedOnManagementFilters", {
      deviceid: deviceid,
      bookingid: booking.id,
    });
    unsavedchangesonform.value = false;
    try {
      const fetchedBooking = await getBooking(booking.id);
      if (fetchedBooking === undefined) {
        actProperty.displayError(
          `Could not find booking with ID ${route.params.id}`
        );
        router.push({ name: "newbooking" });
      }
    } catch (err) {
      actProperty.displayError(err);
    }
    smsemailselectedbooking.value = booking;
    emit("smslogsselected", booking, "fromunreadmessages");
    // Wait for 2 seconds, to check if there is form open on another tab and the appointment loaded
    setTimeout(() => {
      if (smsemailselectedbooking.value.id != smsemailselectedbookingid.value) {
        window.open(`/diary/${smsemailselectedbooking.value.id}`, "_blank");
        smsemailselectedbookingid.value = booking.id;
      }
    }, 2000);
    if (unsavedchangesonform.value) {
      smsemailselectedbookingid.value = "";
      unsavedchangesonform.value = false;
    }
  }
};

const removesmsbookingfromlocal = (booking: Booking, flag: string) => {
  emit("removesmsbookingfromlocal", booking, flag);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.results && _ctx.results.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.todaysunreadsmslogsresults && _ctx.todaysunreadsmslogsresults.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todaysunreadsmslogsresults, (booking) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col-md-12 pt-2 pb-2", {
            'selected-booking':
              (booking.id &&
                smsemailselectedbooking.value.id &&
                booking.id === smsemailselectedbooking.value.id) ||
              (booking.googleid &&
                smsemailselectedbooking.value.googleid &&
                booking.googleid === smsemailselectedbooking.value.googleid),
            'cancelled-booking': booking.cancelled,
            'focused-booking': isfocused(booking),
          }]),
                    key: booking.id
                  }, [
                    _createVNode(UnreadSmsEmailLogstResultTemplate, {
                      templateModel: { appointmentData: booking },
                      picolour: false,
                      rightclick: false,
                      showdate: true,
                      onClick: _withModifiers(($event: any) => (selectbooking(booking)), ["prevent"]),
                      onRemovesmsbookingfromlocal: removesmsbookingfromlocal
                    }, null, 8, ["templateModel", "onClick"])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (
          _ctx.daterangeunreadsmslogsresults && _ctx.daterangeunreadsmslogsresults.length
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daterangeunreadsmslogsresults, (booking) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col-md-12 pt-2 pb-2", {
            'selected-booking':
              (booking.id &&
                smsemailselectedbooking.value.id &&
                booking.id === smsemailselectedbooking.value.id) ||
              (booking.googleid &&
                smsemailselectedbooking.value.googleid &&
                booking.googleid === smsemailselectedbooking.value.googleid),
            'cancelled-booking': booking.cancelled,
            'focused-booking': isfocused(booking),
          }]),
                    key: booking.id
                  }, [
                    _createVNode(UnreadSmsEmailLogstResultTemplate, {
                      templateModel: { appointmentData: booking },
                      picolour: false,
                      rightclick: false,
                      showdate: true,
                      onClick: _withModifiers(($event: any) => (selectbooking(booking)), ["prevent"]),
                      onRemovesmsbookingfromlocal: removesmsbookingfromlocal
                    }, null, 8, ["templateModel", "onClick"])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.futureunreadsmslogsresults && _ctx.futureunreadsmslogsresults.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.futureunreadsmslogsresults, (booking) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col-md-12 pt-2 pb-2", {
            'selected-booking':
              (booking.id &&
                smsemailselectedbooking.value.id &&
                booking.id === smsemailselectedbooking.value.id) ||
              (booking.googleid &&
                smsemailselectedbooking.value.googleid &&
                booking.googleid === smsemailselectedbooking.value.googleid),
            'cancelled-booking': booking.cancelled,
            'focused-booking': isfocused(booking),
          }]),
                    key: booking.id
                  }, [
                    _createVNode(UnreadSmsEmailLogstResultTemplate, {
                      templateModel: { appointmentData: booking },
                      picolour: false,
                      rightclick: false,
                      showdate: true,
                      onClick: _withModifiers(($event: any) => (selectbooking(booking)), ["prevent"]),
                      onRemovesmsbookingfromlocal: removesmsbookingfromlocal
                    }, null, 8, ["templateModel", "onClick"])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.results.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}
}

})